import { Box, Container } from "@mui/material";
import { useState } from "react";
import DataLoadingFailed from "@entrilia/shared/components/DataLoadingFailed";
import RecordCounter from "@entrilia/shared/components/filters/RecordCounter";
import DataGrid from "@entrilia/shared/components/grid/DataGrid";
import SearchField from "@entrilia/shared/components/inputs/SearchField";
import useFetch from "@entrilia/shared/hooks/useFetch";
import adminApi from "../../../../api/adminApi";
import type { ObjectClassDefinitionInfo } from "../../../../api/types/objectTypes";
import { columnDefinitions } from "./objectsGridDataProvider";

const getRowId = (row: ObjectClassDefinitionInfo) => row.objectType;

const ObjectsList = () => {
  const [searchTerm, setSearchTerm] = useState("");

  const [objects, error, { isFetching }] = useFetch(adminApi.getOrganizationObjectDefinitions);

  if (error) {
    return <DataLoadingFailed title="Failed to load objects" />;
  }

  const handleSearch = (value: string) => {
    setSearchTerm(value.trim().toLocaleLowerCase());
  };

  const filteredObjects = searchTerm
    ? (objects ?? []).filter((object) => object.objectName.toLocaleLowerCase().includes(searchTerm))
    : (objects ?? []);

  return (
    <Container maxWidth="lg" disableGutters sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
        <RecordCounter records={filteredObjects.length} totalRecords={objects?.length ?? 0} hide={isFetching} />
        <SearchField debounceTimeMs={300} onSearch={handleSearch} />
      </Box>
      <DataGrid<ObjectClassDefinitionInfo>
        columns={columnDefinitions}
        rows={filteredObjects}
        getRowId={getRowId}
        containerSx={{ height: "auto", minHeight: 0 }}
        loading={isFetching}
        noRowsText={searchTerm ? "No objects match your search" : "No objects yet"}
        disableColumnReorder
      />
    </Container>
  );
};

export default ObjectsList;
